import React from 'react';
import Button from '@material-ui/core/Button';
import tick from '../../../../assets/images/tick.svg';
import theme from '../../../../theme';
import stylesParent from '../frame.module.scss';
import styles from '../styles/stake/stake-success.module.scss';
import TxID from '../../../../components/txID';
import PropTypes from 'prop-types';

const Success = ({ title, token, txId, doneClick, description }) => {
  return (
    <div className={stylesParent.cardContent}>
      <div className={styles.icon}>
        <img src={tick} alt='' />
      </div>
      {token ? (
        <div className={styles.stakedValue} style={{ color: theme.palette.mantra.pink }}>
          {token}
        </div>
      ) : null}
      <div className={styles.status}>{title}</div>
      <TxID id={txId} />
      {description ? (
        <div>
          <div className={styles.description}>{description}</div>
        </div>
      ) : null}
      <div className={stylesParent.cardFooterControls}>
        <Button
          onClick={doneClick}
          variant='contained'
          color='secondary'
          className={stylesParent.cardFooterControlsButton}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

Success.propTypes = {
  title: PropTypes.string.isRequired,
  token: PropTypes.string,
  txId: PropTypes.string.isRequired,
  doneClick: PropTypes.func.isRequired,
  description: PropTypes.string,
};

export default Success;
